(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/collections/prolongwagers.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/collections/prolongwagers.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.collections.ProlongWagers = Backbone.Collection.extend({
    model: svs.maltipset.models.ProlongWager,
    preserve: true,
    isFetching: false,
    hasOngoingGames: false,
    hasMoreItemsToFetch: true,
    url:
      svs.core.jupiter.url() +
      '/multifetch?urls=' +
      encodeURIComponent(
        '/player/wagers?status=Finished&productId=Maltipset&count=20|/player/wagers?status=Active&productId=Maltipset&count=1'
      ),
    initialize: function() {
      this.fetch();
    },
    parse: function(response) {
      if (!response.responses[0].error) {
        this.hasOngoingGames =
          !_.isUndefined(response.responses[1]) &&
          response.responses[1].wagers &&
          response.responses[1].wagers.length > 0;
        return this.getWagersToShow(response.responses[0].wagers);
      }
      svs.components.Modal.hide();
      svs.sport.sport_common.showErrorDialog(
        'Nu gick något fel',
        'Det gick inte att hämta avgjorda spel. Försök senare.'
      );
    },
    getMoreItems: function(successFn, errorFn) {
      this.isFetching = true;
      var self = this,
        url =
          '/player/wagers?status=Finished&productId=Maltipset&count=20&pagingSortKey=' +
          this.last().get('pagingSortKey'),
        options = {
          method: 'GET',
          path: url
        };
      svs.core.jupiter.call(
        options,
        function(data) {
          self.hasMoreItemsToFetch = data.moreItems;
          self.add(self.getWagersToShow(data.wagers));
          self.isFetching = false;
          successFn(data);
        },
        errorFn
      );
    },

    getWagersToShow: function(wagers) {
      var wagersToShow = [];
      _.each(wagers, function(wager) {
        if (!wager.isUserBoards && !wager.isFraction) {
          wagersToShow.push(wager);
        }
      });
      return wagersToShow;
    }
  });
})(Backbone, _, svs);

 })(window);